import * as Yup from 'yup'

export const SPONSOR_NAME = 'sponsorName'
export const SPONSOR_INDUSTRY = 'industry'
export const SPONSOR_OBJECTIVES = 'intent'
export const SPONSOR_DEMOGRAPHICS = 'demographics'
export const CREATIVE_IDEAS = 'creative_ideas'
export const RECIPIENT_TYPE = 'recipient_type'
export const ADDITIONAL_NOTES = 'additional_notes'
export const AUDIENCES_TO_TARGET = '1PD_audiences_to_target'
export const PREFERRED_CHANNELS = 'preferred_channels'
export const OUTPUT_FORMAT = 'output_format'
export const OUTPUT_FORMAT_OTHER = 'output_format_other'
export const OUTPUT_FORMAT_OTHER_TEXT = 'output_format_other_text'

export const FILES = 'files'
export const FILE_URL = 'file_url'

export const preferredChannelsOptions = [
  {
    label: 'Facebook',
    value: 'Facebook'
  },
  {
    label: 'Instagram',
    value: 'Instagram'
  },
  {
    label: 'DV360',
    value: 'DV360'
  },
  {
    label: 'TikTok',
    value: 'TikTok'
  },
  {
    label: 'GAM360',
    value: 'GAM360'
  },
  {
    label: 'LinkedIn',
    value: 'LinkedIn'
  }
]

export const outputFormatOptions = [
  {
    label: 'One slide for a sales deck',
    value: 'One slide for a sales deck'
  },
  {
    label: 'Two slides for a sales deck',
    value: 'Two slides for a sales deck'
  },
  {
    label: 'Content for a 6 slide sales deck',
    value: 'Content for a 6 slide sales deck'
  },
  {
    label: 'One paragraph for an email',
    value: 'One paragraph for an email'
  },
  {
    label: 'A dedicated email',
    value: 'A dedicated email'
  },
  {
    label: 'Other',
    value: OUTPUT_FORMAT_OTHER
  }
]

export const initialValues = {
  [SPONSOR_NAME]: '',
  [SPONSOR_INDUSTRY]: '',
  [SPONSOR_OBJECTIVES]: '',
  [SPONSOR_DEMOGRAPHICS]: '',
  [CREATIVE_IDEAS]: '',
  [RECIPIENT_TYPE]: '',
  [ADDITIONAL_NOTES]: '',
  [AUDIENCES_TO_TARGET]: [],
  [PREFERRED_CHANNELS]: [],
  [OUTPUT_FORMAT]: 'Short deck',
  [OUTPUT_FORMAT_OTHER]: '',
  [FILES]: {}
}

export const validationSchema = Yup.object({
  [SPONSOR_NAME]: Yup.string().required('Sponsor name is required'),
  [SPONSOR_INDUSTRY]: Yup.string().required('Industry is required')
})
